import type { BlankEnum, LanguageEnum } from '@bambi/api-client/schemas';

import type { LanguageSelectOption } from './LanguageSelect';

const LANGUAGE_LABELS: Record<
  LanguageEnum,
  { label: string; nativeLabel: string }
> = {
  en: { label: 'English', nativeLabel: 'English' },
  es: { label: 'Spanish', nativeLabel: 'Español' },
};

export const languageOptions: LanguageSelectOption<LanguageEnum>[] = (
  Object.entries(LANGUAGE_LABELS) as [
    LanguageEnum,
    { label: string; nativeLabel: string },
  ][]
).map(([value, names]) => ({ value, ...names }));

export function getLanguageLabel(language?: LanguageEnum | BlankEnum): string {
  return (
    languageOptions.find((option) => option.value === language)?.label ||
    (language ?? '')
  );
}
